/**
 * Ness Frame Character 옵션 그룹 유틸리티 (Frontend 전용)
 * box 전역 객체 사용
 */
import { selectedOptionGroupUtil } from '@modules/BpOption/S/Function/selected-option-group.util';
import { AssocBpOptionGroup, bpOptionUtil } from '@modules/BpOption/S/Function/bp-option.util';
import { SelectedOptionGroups } from '@services/database/mco/schema/public';
import { compact } from '@fxts/core';
import { FrameCharacter, NessFrameDetails } from '../S/constant';

// ============================================
// Helper Functions
// ============================================
function makeOutput(
  selected_option_group: SelectedOptionGroups,
  bp_option_groups: AssocBpOptionGroup[],
  selected_bp_option_id: number,
  details?: NessFrameDetails,
) {
  const bp_option_ids = selectedOptionGroupUtil.makeSelectedBpOptionIds(
    {
      selected_option_group,
      bp_option_groups,
    },
    selected_bp_option_id,
  );
  const frame_option_names = bpOptionUtil.makeOptionNamesByDevNameAndBpOptionId(bp_option_groups, {
    selected_bp_option_ids: bp_option_ids,
    dev_name: 'NESS_FRAME',
  });

  const character_option_names = bpOptionUtil.makeOptionNamesByDevNameAndBpOptionId(bp_option_groups, {
    selected_bp_option_ids: bp_option_ids,
    dev_name: 'NESS_CHARACTERS',
  });

  details = details !== undefined ? details : (selected_option_group.details as NessFrameDetails);
  if (character_option_names) {
    const character_names = details?.value?.frame_characters.map(({ gc_name }) => gc_name).join(', ');
    if (character_names) {
      character_option_names.option_name = character_names;
      character_option_names.option_name_en = character_names;
      character_option_names.option_name_jp = character_names;
    }
  }

  return {
    bp_option_ids,
    title: '',
    option_names: compact([frame_option_names, character_option_names]),
    details,
  };
}

// ============================================
// Exported Object
// ============================================
export const SelectedOptionGroupForFrameCharacter = {
  getSelectedOptionGroup: () => {
    return box.sel('product_detail->selected_option_group');
  },

  setBpOptionOutputForBpOptionId(selected_bp_option_id: number): SelectedOptionGroups {
    const bp_option_groups = box.sel('product_detail->base_product->_->bp_option_groups');
    const selected_option_group = box.sel('product_detail->selected_option_group');
    Object.assign(
      selected_option_group,
      makeOutput(selected_option_group, bp_option_groups, selected_bp_option_id),
    );
    return selected_option_group;
  },

  setBpOptionOutputForCharacter(frame_characters: FrameCharacter[]): SelectedOptionGroups | undefined {
    const bp_option_groups = box.sel('product_detail->base_product->_->bp_option_groups');
    const selected_option_group = box.sel('product_detail->selected_option_group');
    const bp_option_group = bpOptionUtil.getBpOptionGroupByDevName(bp_option_groups, 'NESS_CHARACTERS');
    if (!bp_option_group) return;
    const characters_count = frame_characters.length;
    const selected_bp_option = bp_option_group._.bp_options.find(
      ({ dev_name }) => Number(dev_name) === characters_count,
    );
    if (!selected_bp_option) return;
    Object.assign(
      selected_option_group,
      makeOutput(
        selected_option_group,
        bp_option_groups,
        selected_bp_option.id,
        frame_characters?.length
          ? {
              type: 'NESS_CHARACTER_INFO',
              value: {
                frame_characters,
              },
            }
          : null,
      ),
    );
    return selected_option_group;
  },
};
